import {I18n} from 'aws-amplify/utils';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {DomainName} from '../types';
import {
    ActionIcon,
    Group
} from "@mantine/core";
import {AiOutlineLink} from "react-icons/ai";
import {DataTableColumn} from "mantine-datatable";

export const columns: DataTableColumn<DomainName>[] = [
    {
        accessor: 'name',
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: DomainName) => <Group>
            <NavLink to={`/domain-names/${item.id}`}>{item.name}</NavLink>
            <ActionIcon variant={"subtle"} onClick={() => window.open('http://' + item.name)}>
                <AiOutlineLink/>
            </ActionIcon>
        </Group>,
    },
    {
        accessor: 'registrarId',
        title: I18n.get('Registrar'),
        width: '1fr',
        render: (item: DomainName) => <NavLink to={`/registrars/${item.registrarId}`}>{item.registrar?.name}</NavLink>,
    },
    {
        accessor: 'category',
        title: I18n.get('Category'),
        width: '1fr',
        render: (item: DomainName) => item.category,
    },
    {
        accessor: 'tldId',
        title: I18n.get('TLD'),
        width: '1fr',
        render: (item: DomainName) => <NavLink
            to={`/top-level-domains/${item.tldId}`}>{item.topLevelDomain?.name}</NavLink>,
    },
    {
        accessor: 'created',
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: DomainName) => formatTimestamp(item.created as string),
    },
];
